import React, { Component, Ref } from "react";

import withGameGridContainerConfiguration from "./configuration/withGameLevelGridContainerConfiguration";

import GameGrid from "./../gameGrid/gameGrid"
import { Container, Graphics, Sprite, withPixiApp } from "@inlet/react-pixi";
import UIManager from "../../core/components/ui/UiBuilder";
import { connect } from "react-redux";
import { GJIStore } from "../../gamestore/IStore";
import { Dispatch } from "redux";
import { CURRENCY, TIMER } from "../../core/utills";

import { actions as layoutssActions } from "../../core/reducers/layoutsStateReducer";

import Symbolanimation from "../../core/components/symbol/symbolanimation";


interface IProps {
    [x: string]: any;

}

interface IState {

}

interface IStateToProps {

    layoutMode: string

}

interface IDispatchToProps {

}


class GameGridContainer extends Component<IProps, IState> {

    protected app: PIXI.Application;
    protected gridContainer: any;
    protected gridList: Array<any>;

    constructor(props: IProps) {
        super(props);

        this.app = props.app;
        this.gridList = [];
    }

    componentDidMount() {
        if (!this.props.data.HIDE_MASK) {
            this.onReelMaskOn()
        }

    }

    layoutChange(currentLayout: string) {

    }

    shouldComponentUpdate(nextProps: Readonly<IProps>, nextState: Readonly<IState>, nextContext: any): boolean {

        if (nextProps.layoutMode !== this.props.layoutMode) {
            this.layoutChange(nextProps.layoutMode)
            return false;
        }

        return true;
    }

    bindEvent() {

    }

    onReelMaskOn() {

        const thing = new PIXI.Graphics();
        thing.beginFill(0xDE3249);
        thing.drawRect(0, 0, (this.props.data.GRID_WIDTH + this.props.data.GRID_GAP) * this.props.data.GRID_COLUMN, this.props.data.SYMBOL_HEIGHT * this.props.data.GRID_ROWS);
        thing.endFill();
        this.gridContainer.addChild(thing);
        thing.x = 0;
        thing.y = 0;
        this.gridContainer.mask = thing;
        //this.gridContainer.visible = false;

        // let timer = TIMER.TimerManager.createTimer(200);
        // timer.on('end', (e: any) => {
        //     this.gridContainer.visible = true;
        // });
        // timer.start();
    }


    onReelMaskOff() {
        this.gridContainer.mask = null;
    }


    render() {
        let reelContainerX = this.props.data.GRID_CONTAINER_X, reelContainerY = this.props.data.GRID_CONTAINER_Y,
            scalingOfReelContainer = this.props.data.REEL_CONTAINER_SCALE

        const reels_array = [];
        for (var i = 0; i < this.props.data.GRID_COLUMN; i++) {
            let PROPS_TO_SEND_Grid = {
                key: "grid" + i,
                name: "grid" + i,
                canvasApp: this.app,
                GridIndex: i,
                gridList: this.gridList,
            }
            reels_array.push(<GameGrid {...PROPS_TO_SEND_Grid} />);
        }
        return (<>
            {this.props.data.child && this.props.data.child.map((i: any) => <UIManager
                key={`UIManager-${Math.random()}`} type={i.type}
                id={i.id} {...i} />)}
            <Container ref={i => this.gridContainer = i} x={reelContainerX} y={reelContainerY} name={"gameGridContainer"}>
                {reels_array}
            </Container>

        </>)
    }
}

export default withPixiApp(connect(
    (state: Pick<GJIStore, 'applicationState'>): IStateToProps =>
    ({
        layoutMode: state.applicationState.layoutMode,
    }),
    (dispatch: Dispatch): IDispatchToProps => ({
        setApplicationLayoutObject: (layoutobjectlist: string): any => dispatch(layoutssActions.setApplicationLayoutObject(layoutobjectlist)),
    }))(withGameGridContainerConfiguration(GameGridContainer)));